// extracted by mini-css-extract-plugin
export var cardLayout = "_9d-1";
export var paginationContainer = "_9d-0";